(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------------------
     Scroll-reveal — IntersectionObserver only, never a scroll listener.
     -------------------------------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --------------------------------------------------------------------
     Header scroll state — sentinel + IntersectionObserver, no scroll
     listener. Also handles the mobile menu toggle.
     -------------------------------------------------------------------- */
  function initHeader() {
    var header = document.querySelector('.site-header');
    var sentinel = document.getElementById('HeaderSentinel');
    if (header && sentinel && 'IntersectionObserver' in window) {
      var headerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          header.classList.toggle('is-scrolled', !entry.isIntersecting);
        });
      });
      headerObserver.observe(sentinel);
    } else if (header) {
      header.classList.add('is-scrolled');
    }

    var toggle = header ? header.querySelector('.site-header__menu-toggle') : null;
    if (toggle && header) {
      toggle.addEventListener('click', function () {
        var isOpen = header.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  }

  /* --------------------------------------------------------------------
     Brand film play / pause toggle.
     -------------------------------------------------------------------- */
  function initBrandFilm() {
    var section = document.querySelector('.brand-film');
    if (!section) return;

    var video = section.querySelector('video');
    var toggle = section.querySelector('.brand-film__toggle');
    if (!video || !toggle) return;

    var icon = toggle.querySelector('use');
    var label = toggle.querySelector('.brand-film__toggle-label');

    function setState(playing) {
      if (icon) icon.setAttribute('href', playing ? '#icon-pause' : '#icon-play');
      if (label) label.textContent = playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel;
      toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
    }

    if (reduceMotion) {
      video.pause();
      video.removeAttribute('autoplay');
      setState(false);
    } else {
      setState(!video.paused);
    }

    toggle.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        setState(true);
      } else {
        video.pause();
        setState(false);
      }
    });
  }

  /* --------------------------------------------------------------------
     Sticky add-to-bag bar — shown once the main buy box scrolls past.
     -------------------------------------------------------------------- */
  function initStickyBuyBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    var sentinel = document.querySelector('[data-sticky-sentinel]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          bar.hidden = false;
        });
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  }

  /* --------------------------------------------------------------------
     Product image zoom — click/tap to open, native pinch-zoom on mobile.
     -------------------------------------------------------------------- */
  function initProductZoom() {
    var modal = document.getElementById('ProductZoomModal');
    var modalImage = document.getElementById('ProductZoomImage');
    if (!modal || !modalImage) return;

    var lastFocused = null;

    function open(src, alt) {
      modalImage.src = src;
      modalImage.alt = alt || '';
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      var closeBtn = modal.querySelector('[data-zoom-close]');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') close();
    }

    var trigger = document.querySelector('[data-product-zoom-trigger]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        if (trigger.classList.contains('is-video')) return;
        open(trigger.dataset.zoomSrc, trigger.querySelector('img') ? trigger.querySelector('img').alt : '');
      });
    }

    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-product-thumb]'));
    var tagEl = document.querySelector('[data-gallery-tag]');
    var currentIndex = 0;

    function selectThumb(index) {
      var thumb = thumbs[index];
      if (!thumb) return;
      currentIndex = index;

      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
      });

      var mainImg = document.querySelector('[data-product-main-image]');
      var mainVideo = document.querySelector('[data-product-main-video]');
      var isVideo = thumb.dataset.mediaType === 'video';

      if (trigger) trigger.classList.toggle('is-video', isVideo);

      if (isVideo) {
        if (mainVideo && thumb.dataset.videoSrc) {
          mainVideo.src = thumb.dataset.videoSrc;
          mainVideo.hidden = false;
          mainVideo.play();
        }
        if (mainImg) mainImg.hidden = true;
      } else {
        if (mainVideo) {
          mainVideo.pause();
          mainVideo.removeAttribute('src');
          mainVideo.hidden = true;
        }
        if (mainImg) {
          mainImg.hidden = false;
          if (thumb.dataset.fullSrc) mainImg.src = thumb.dataset.fullSrc;
        }
      }

      if (trigger) {
        if (thumb.dataset.zoomSrc) trigger.dataset.zoomSrc = thumb.dataset.zoomSrc;
      }
      if (tagEl) {
        if (thumb.dataset.tag) {
          tagEl.textContent = thumb.dataset.tag;
          tagEl.hidden = false;
        } else {
          tagEl.hidden = true;
        }
      }
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        selectThumb(index);
      });
    });

    if (thumbs.length) thumbs[0].classList.add('is-active');

    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        selectThumb((currentIndex - 1 + thumbs.length) % thumbs.length);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        selectThumb((currentIndex + 1) % thumbs.length);
      });
    }

    var viewport = document.querySelector('.product-gallery__viewport');
    if (viewport && thumbs.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;

      viewport.addEventListener(
        'touchstart',
        function (event) {
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        function (event) {
          var dx = event.changedTouches[0].clientX - touchStartX;
          var dy = event.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          if (dx < 0) {
            selectThumb((currentIndex + 1) % thumbs.length);
          } else {
            selectThumb((currentIndex - 1 + thumbs.length) % thumbs.length);
          }
        },
        { passive: true }
      );
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal) close();
    });

    var closeBtn = modal.querySelector('[data-zoom-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
  }

  /* --------------------------------------------------------------------
     Bundle contents tabs.
     -------------------------------------------------------------------- */
  function initBundleTabs() {
    var tabs = document.querySelectorAll('[data-bundle-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var container = tab.closest('[data-tabs-container]');
        if (!container) return;

        container.querySelectorAll('[data-bundle-tab]').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        container.querySelectorAll('.bundle-contents__panel').forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.hidden = true;
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        var target = document.getElementById(tab.dataset.target);
        if (target) {
          target.classList.add('is-active');
          target.hidden = false;
        }
      });
    });
  }

  /* --------------------------------------------------------------------
     Routine finder quiz — deterministic 2-question flow, all outcomes
     rendered server-side, JS only toggles visibility.
     -------------------------------------------------------------------- */
  function initRoutineQuiz() {
    var root = document.querySelector('[data-routine-quiz]');
    if (!root) return;

    var step1 = root.querySelector('[data-quiz-step="1"]');
    var step2 = root.querySelector('[data-quiz-step="2"]');
    var results = root.querySelector('[data-quiz-results]');
    var dots = root.querySelectorAll('[data-quiz-dot]');
    var answers = {};

    var RESULT_MAP = {
      correct: { one: 'correct-dark-spot-correcting-serum', two: 'daily-essentials-routine', four: 'complete-routine' },
      hydrate: { one: 'hydrate-daily-moisturiser', two: 'daily-essentials-routine', four: 'complete-routine' },
      protect: { one: 'protect-spf50-invisible-sun-stick', two: 'daily-essentials-routine', four: 'complete-routine' }
    };

    function setDot(n) {
      dots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.dataset.quizDot === String(n));
      });
    }

    function showStep(n) {
      results.hidden = true;
      step1.hidden = n !== 1;
      step2.hidden = n !== 2;
      setDot(n);
    }

    function showResult(handle) {
      step1.hidden = true;
      step2.hidden = true;
      results.hidden = false;
      results.querySelectorAll('[data-quiz-result]').forEach(function (card) {
        card.hidden = card.dataset.quizResult !== handle;
      });
    }

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-quiz-option]');
      if (option) {
        var question = option.dataset.question;
        var value = option.dataset.value;
        answers[question] = value;

        if (question === 'concern') {
          if (value === 'all') {
            showResult('complete-routine');
          } else {
            showStep(2);
          }
        } else if (question === 'steps') {
          var byConcern = RESULT_MAP[answers.concern];
          var handle = byConcern ? byConcern[value] : 'complete-routine';
          showResult(handle || 'complete-routine');
        }
        return;
      }

      if (event.target.closest('[data-quiz-back]')) {
        showStep(1);
        return;
      }

      if (event.target.closest('[data-quiz-retake]')) {
        answers = {};
        showStep(1);
      }
    });
  }

  /* --------------------------------------------------------------------
     "Our Community" UGC video row (sections/our-community.liquid) — each
     card's video is click-to-play (never autoplay), same play/pause toggle
     convention as initBrandFilm() above. The one addition: starting a video
     pauses whichever other card video is currently playing, since 4 clips
     with sound should never overlap.
     -------------------------------------------------------------------- */
  function initCommunityVideos() {
    var cards = document.querySelectorAll('.our-community__card');
    if (!cards.length) return;

    var videos = [];
    cards.forEach(function (card) {
      var video = card.querySelector('[data-community-video]');
      var toggle = card.querySelector('[data-community-play]');
      if (!video || !toggle) return;

      videos.push(video);

      function setState(playing) {
        toggle.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        if (video.paused) {
          videos.forEach(function (other) {
            if (other !== video) other.pause();
          });
          video.play();
        } else {
          video.pause();
        }
      });

      video.addEventListener('click', function () {
        toggle.click();
      });

      video.addEventListener('play', function () { setState(true); });
      video.addEventListener('pause', function () { setState(false); });
    });
  }

  /* --------------------------------------------------------------------
     Localization form (country/currency + language selects) — submits
     the form automatically when either select changes, since the
     <noscript> submit button is invisible once JS has loaded.
     -------------------------------------------------------------------- */
  function initLocalizationForm() {
    var selects = document.querySelectorAll('[data-localization-select]');
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeader();
    initBrandFilm();
    initStickyBuyBar();
    initProductZoom();
    initBundleTabs();
    initRoutineQuiz();
    initCommunityVideos();
    initLocalizationForm();
  });
})();
